var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column gap-3"},[_c('h3',{staticClass:"m-0"},[_vm._v("Bookmarks")]),_c('bookmarks-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }